import * as React from "react";
import { CardPaymentPlan } from "../../generated/UserAPIAgent";
import { NewPayment } from "../../store/payment";

interface PlanPriceProps {
    // ユーザーが購入しようとしているプラン
    selectedPaymentPlan?: NewPayment;
    // selectedPaymentPlanが存在しない場合、
    // PaymentStatusObj.cardPaymentPlansから表示
    cardPaymentPlan: CardPaymentPlan | null;
}
export const PlanPrice = (props: PlanPriceProps): JSX.Element => {
    const amountOfMoney = (() => {
        if (props.selectedPaymentPlan) {
            if (
                props.selectedPaymentPlan.firstAmount &&
                props.selectedPaymentPlan.amount >
                    props.selectedPaymentPlan.firstAmount
            ) {
                return `初月 ${Intl.NumberFormat().format(
                    props.selectedPaymentPlan.firstAmount
                )}円 翌月以降 ${Intl.NumberFormat().format(
                    props.selectedPaymentPlan.amount
                )}円`;
            } else {
                return `${Intl.NumberFormat().format(
                    props.selectedPaymentPlan.amount
                )}円 / 月`;
            }
        }
        if (
            props.cardPaymentPlan.campaigns.length > 0 &&
            props.cardPaymentPlan.campaigns[0].firstAmount !==
                props.cardPaymentPlan.amount
        ) {
            return `初月 ${Intl.NumberFormat().format(
                props.cardPaymentPlan.campaigns[0].firstAmount
            )}円 翌月以降 ${Intl.NumberFormat().format(
                props.cardPaymentPlan.amount
            )}円`;
        } else {
            return `${Intl.NumberFormat().format(
                props.cardPaymentPlan.amount
            )}円 / 月`;
        }
    })();
    return <>{amountOfMoney}</>;
};
